import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, filter, map, mergeMap, withLatestFrom } from 'rxjs/operators';
import { ratesActions } from '.';
import { ApiError } from '../../models/common/api-error';
import { of } from 'rxjs';
import { RatesService } from '../../services/rates.service';
import { fromStore } from '..';

@Injectable({
  providedIn: 'root',
})
export class RatesEffects {
  constructor(
    private store$: Store,
    private actions$: Actions,
    private ratesService: RatesService,
  ) {}

  needRates$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ratesActions.needRates),
      withLatestFrom(this.store$.select(fromStore.selectRatesState)),
      filter(([action, ratesState]) => {
        // Charge uniquement si les données ne sont pas déjà chargées et pas en cours de chargement
        return ratesState.entitiesCount === 0 && !ratesState.loading;
      }),
      map(([action]) => ratesActions.findAll({ vendorId: action.vendorId })),
    ),
  );

  findAll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ratesActions.findAll),
      withLatestFrom(this.store$),
      mergeMap(([action, store]) => {
        return this.ratesService.findAll(action.vendorId).pipe(
          map((response) =>
            ratesActions.findAllSuccess({
              rates: response.data,
              total: response.total,
            }),
          ),
          catchError((error: ApiError) =>
            of(ratesActions.findError({ error: error.message })),
          ),
        );
      }),
    ),
  );
}
